export default (theme: Object) => ({
  inviteError: {
    display: 'flex',
    flexFlow: 'column',
    color: theme.palette.neutrals.secondaryText,
  },
});
